import { useTranslation } from 'react-i18next';
import { marked } from 'marked';
import xss from 'xss';
import {
    Banner,
    BannerDescription,
    BannerEyebrow,
    BannerImage,
    BannerImageContainer,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    BoundedContent,
    Button,
    FluidImage,
    Link,
} from '@vp/swan';
import { sanitiseLocale } from '../../../../i18n/config';
import { logomakerCtaPathByLocale } from '../../../../utils/urls';

const FeatureBannerAiQuality = () => {
    const { t, i18n } = useTranslation();
    const locale = sanitiseLocale(i18n.language);

    return (
        <BoundedContent as="section" id="ai-quality">
            <Banner backgroundColor="standard">
                <BannerTextContainer>
                    <BannerText>
                        <BannerEyebrow>
                            {t(
                                'Logomaker GenAi Landing Page > Feature Banner AI Quality > Eyebrow.value',
                            )}
                        </BannerEyebrow>
                        <BannerTitle as="h2" fontSkin="title-section">
                            {t(
                                'Logomaker GenAi Landing Page > Feature Banner AI Quality > Title.value',
                            )}
                        </BannerTitle>
                        <BannerDescription
                            as="p"
                            dangerouslySetInnerHTML={{
                                __html: xss(
                                    marked.parse(
                                        t(
                                            'Logomaker GenAi Landing Page > Feature Banner AI Quality > Description.value',
                                        ),
                                    ) as string,
                                ),
                            }}
                        />
                        <BannerLinks display={{ xs: 'none', sm: 'flex' }}>
                            <Button
                                skin="primary"
                                render={(props) => (
                                    // TODO: Add tracking
                                    <Link
                                        to={logomakerCtaPathByLocale(locale)}
                                        className={props.className}
                                    >
                                        {props.children}
                                    </Link>
                                )}
                            >
                                {t(
                                    'Logomaker GenAi Landing Page > Feature Banner AI Quality > CTA Text.value',
                                )}
                            </Button>
                        </BannerLinks>
                    </BannerText>
                </BannerTextContainer>
                <BannerImageContainer>
                    <BannerImage>
                        <FluidImage
                            src={t(
                                'Logomaker GenAi Landing Page > Feature Banner AI Quality > Image.src',
                            )}
                            alt={t(
                                'Logomaker GenAi Landing Page > Feature Banner AI Quality > Image > Alt Text.value',
                            )}
                        />
                    </BannerImage>
                </BannerImageContainer>
            </Banner>
        </BoundedContent>
    );
};

export default FeatureBannerAiQuality;
